import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from 'src/AppContext';
import { parse } from 'querystring';
import Button from 'src/components/Button';
import { Trans, useTranslation } from 'react-i18next';
import useCustomHistory from 'src/hooks/useCustomHistory';

export default function PasswordSend(): JSX.Element {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const history = useCustomHistory();
  const location = useLocation();
  const { email } = parse(location.search.replace(/^[?]/gi, ''));

  useLayoutEffect(() => {
    dispatch({ type: 'SET_GNB_LEFT', name: 'hidden' });
    dispatch({ type: 'SET_GNB_RIGHT', name: 'close' });
    dispatch({
      type: 'SET_GNB_RIGHT_CALLBACK',
      cb: () => {
        history.push('/login');
      },
    });
    return () => {
      dispatch({ type: 'RESET_GNB_LEFT' });
      dispatch({ type: 'RESET_GNB_RIGHT' });
      dispatch({ type: 'RESET_GNB_RIGHT_CALLBACK' });
    };
  }, []);

  return (
    <>
      <div className="container mt-6">
        <h1 className="N_20_R">{t('password/send/title')}</h1>
        <div className="mt-7 N_14_R text-brown-grey">
          <Trans
            i18nKey="password/send/subtitle_1"
            values={{ email }}
            components={{ span: <span className="text-bluey-purple font-medium" /> }}
          ></Trans>
        </div>
        <div className="mt-4 N_14_R text-brown-grey">{t('password/send/subtitle_2')}</div>
        <div className="mt-10">
          <Button title={t('account/complete/login_button')} theme="sub" onClick={() => history.push('/login')}></Button>
        </div>
      </div>
      <ul className="container mt-10 py-6 N_12_R text-brown-grey bg-pale-grey list-disc">
        <li>{t('password/reset/disclaimer_1')}</li>
      </ul>
    </>
  );
}
